export const iconFontAwesomeHumanitarianTruckArrowRight = (
	<i className="fa-solid fa-truck-arrow-right"></i>
);
